import React, { useEffect, useState } from 'react';
import { Table, Pagination } from 'antd';
import { TableItem } from '../../../StyledComponents/Common';
import styled from 'styled-components';



const SimpleTable = (props) => {
  const currentData = props?.data
  return (
    <TableContainer>
      <TableItem rowKey={props.rowKey ? props.rowKey : "id"} name={props.name} columns={props.columns} dataSource={currentData} 
      scroll={props.scroll ? {x: props?.xWidth ? props?.xWidth: 1300,} : null} pagination={false} fpadding={props.fpadding} showScroll={props.showScroll} className={props.className? props.className : ""} />
    </TableContainer>
  );
};

export default SimpleTable;

const TableContainer = styled.div`
  /* overflow-x: hidden;
  width: 100%; */
  
`